import React from "react";
import Slider from "react-slick";
import "./client.css";
import century from "../../Assets/century.png";
import continental from "../../Assets/continental.png";
import dsm from "../../Assets/dsm.jpg";
import geico from "../../Assets/geico.png";
import iit from "../../Assets/iit.png";
import LT from "../../Assets/lt.png";
import renuka from "../../Assets/renuka.jpg";
import ril from "../../Assets/ril.png";
import thermax from "../../Assets/thermax.png";
import disa from "../../Assets/disa.jpg";

const Clients = () => {
  const settings = {
    className: "center",
    centerMode: true,useCSS: true,
    infinite: true,
    centerPadding: "90px",
    slidesToShow: 5,
    speed: 1500, arrows: false,
    slidesToScroll: 2,
    autoplay: true,
    autoplaySpeed: 1500,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          centerPadding: "50px",
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          centerPadding: "40px",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          centerPadding: "20px", // Adjusted for smaller screens
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerPadding: "10px", // Adjusted for smaller screens
        },
      },
    ],
  };

  return (
    <section id="clients" className="text-center pt-5 pb-5">
      <div className="container">
        <div className="row">
          <h2 className="client-title">Our Clients</h2>
          <Slider className='slider-width' {...settings}>
            {[ril, thermax, disa, LT, renuka, iit, geico, dsm, century, continental].map((logo, index) => (
              <div key={index} style={{ backgroundColor: 'red', padding: 30 }}>
                <img src={logo} alt="Client Logo" height={100} width={100} className="img-fluid" />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Clients;